<template>
  <div class="h-full">
    <div class="h-full flex" :gutter="10">
      <div class="h-full w-320px flex-shrink-0">
        <el-card class="h-full flex flex-col" :body-style="{ padding: '20px', height: '100%' }">
          <div class="mb-20px flex items-center text-14px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">指标域目录</span>
          </div>
          <div class="flex mb-20px">
            <el-input
              placeholder="指标域编码或名称"
              v-model="treeKeyword"
              class="mr-10px flex-1"
              clearable
              @keyup.enter.native="searchTreeData"
            ></el-input>
            <el-button type="primary" class="!h-36px" size="mini" @click="searchTreeData"
              >搜索</el-button
            >
            <el-button
              :disabled="!$hasAccess('create')"
              type="primary"
              size="mini"
              class="!h-36px"
              @click="handleTreeData($event, 'createParentId')"
              >新增</el-button
            >
          </div>

          <div class="flex-auto tree overflow-y-auto" style="height: calc(100% - 94px)">
            <el-tree
              v-if="showTree"
              v-loading="treeLoading"
              highlight-current
              :data="treeData"
              @node-click="handleDocNodeClick"
              :props="defaultTreeProps"
              :load="loadTreeData"
              node-key="id"
              ref="tree"
              class="h-full"
              :lazy="!isExpandAll"
              :default-expand-all="isExpandAll"
            >
              <div slot-scope="{ node, data }" class="node-item">
                <div class="custom-tree-node">
                  <p :title="node.label" class="flex-1 mr-15px truncate">
                    {{ node.label }}
                  </p>
                  <div class="mr-5px">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <!-- 最多新增三级指标域 -->
                        <el-dropdown-item
                          :disabled="!$hasAccess('create') || node.level === 3"
                          @click.native="handleTreeData($event, 'create', data)"
                          >新增</el-dropdown-item
                        >
                        <el-dropdown-item
                          :disabled="!$hasAccess('update')"
                          @click.native="handleTreeData($event, 'update', data)"
                          >编辑</el-dropdown-item
                        >
                        <el-dropdown-item
                          :disabled="!$hasAccess('delete')"
                          @click.native="removeTreeData(data.id)"
                          >删除</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </el-tree>
          </div>
        </el-card>
      </div>
      <div class="h-full flex-auto ml-10px w-0px">
        <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
          <div class="flex mb-20px">
            <el-input
              size="small"
              clearable
              placeholder="指标编码或名称"
              v-model="search.keyword"
              class="!mr-10px w-200px"
            ></el-input>
            <el-select
              size="small"
              clearable
              placeholder="指标类型"
              v-model="search.type"
              class="!mr-10px w-200px"
              filterable
            >
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              size="small"
              clearable
              placeholder="状态"
              v-model="search.status"
              class="!mr-10px w-200px"
              filterable
            >
              <el-option label="已发布" :value="true"> </el-option>
              <el-option label="已关闭" :value="false"> </el-option>
            </el-select>
            <el-select
              size="small"
              clearable
              placeholder="创建人"
              v-model="search.user"
              class="!mr-10px w-200px"
              filterable
            >
              <el-option v-for="(item, index) in userList" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
            <el-button type="primary" size="small" @click="findList">搜索</el-button>
            <el-button size="small" @click="reset">重置</el-button>
            <el-button
              :disabled="!$hasAccess('create')"
              type="primary"
              size="small"
              @click="showInventory = true"
              >新增指标</el-button
            >
          </div>
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            width="100%"
            height="calc(100% - 106px)"
            border
            stripe
            highlight-current-row
            ref="table"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" width="55" label="序号"> </el-table-column>
            <el-table-column show-overflow-tooltip label="指标名称" prop="name"></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="指标类型"
              prop="typeName"
            ></el-table-column>
            <el-table-column show-overflow-tooltip label="指标编码" prop="code"></el-table-column>
            <el-table-column show-overflow-tooltip label="指标状态" prop="isPublish">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.isPublish ? '已发布' : '已关闭' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="指标域"
              prop="metricsDmainName"
              width="85"
            ></el-table-column>
            <el-table-column show-overflow-tooltip label="数据模型" prop="dataModelName">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="创建人" prop="createdUserName">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="创建时间" prop="createdTime">
            </el-table-column>
            <el-table-column label="操作" align="left" width="400px">
              <template slot-scope="scope">
                发布
                <el-switch
                  v-model="scope.row.isPublish"
                  class="mr-10px"
                  :disabled="!$hasAccess('publish')"
                  @change="updatePublish(scope.row)"
                >
                </el-switch>
                <!-- 原子指标没有指标数据 -->
                <el-button
                  :disabled="!$hasAccess('metricsData') || scope.row.type === 0"
                  size="mini"
                  @click="toMetricsData(scope.row)"
                  >指标数据</el-button
                >
                <el-tooltip
                  placement="top"
                  content="请先关闭已发布指标后进行编辑"
                  :disabled="!scope.row.isPublish"
                >
                  <span class="w-50px ml-10px mr-10px">
                    <el-button
                      :disabled="!$hasAccess('update') || scope.row.isPublish"
                      size="mini"
                      @click="toDetail(scope.row.type, 'update', scope.row.id, scope.row.isPublish)"
                      >编辑</el-button
                    >
                  </span>
                </el-tooltip>
                <el-tooltip
                  placement="top"
                  content="请先关闭已发布指标后进行删除"
                  :disabled="!scope.row.isPublish"
                >
                  <span class="w-50px mr-10px">
                    <el-button
                      :disabled="!$hasAccess('delete') || scope.row.isPublish"
                      size="mini"
                      @click="deleteMetrics(scope.row)"
                      >删除</el-button
                    >
                  </span>
                </el-tooltip>
                <el-button
                  :disabled="!$hasAccess('copy')"
                  size="mini"
                  @click="toDetail(scope.row.type, 'copy', scope.row.id)"
                  >复制</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="flex justify-end mt-20px">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page.pageNo"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size.sync="page.pageSize"
              :total="page.total"
              :page-sizes="$pageSizeAll"
              :pager-count="5"
            >
            </el-pagination>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 新增和编辑指标域 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="treeDialogTitle"
      :visible.sync="showTreeDialog"
      class="small-dialog"
      v-dialogDrag
      :before-close="closeTreeDialog"
    >
      <el-form label-width="150px" :model="treeForm" :rules="treeRules" ref="treeForm">
        <el-form-item label="指标域编码" prop="code">
          <el-input
            placeholder="1-64个字符，仅支持小写英文、数字，不可重名"
            v-model="treeForm.code"
            minlength="1"
            maxlength="64"
            show-word-limit
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="指标域名称" prop="name">
          <el-input
            placeholder="1-64个字符，仅支持中英文、数字，不可重名"
            v-model="treeForm.name"
            minlength="1"
            maxlength="64"
            show-word-limit
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            v-model="treeForm.description"
            clearable
            type="textarea"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" :loading="addTreeLoading" @click="saveTreeData">保存</el-button>
        <el-button @click="closeTreeDialog">取消</el-button>
      </div>
    </el-dialog>

    <!-- 新增指标 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增指标"
      :visible.sync="showInventory"
      width="500px"
      v-dialogDrag
    >
      <div class="w-full h-full">
        <ul>
          <li
            class="flex p-10px h-110px"
            v-for="(item, index) in metricsTypes"
            :key="index"
            @click="toDetail(item.type, 'add')"
          >
            <div class="w-100px border">
              <div class="bg-blue-500 h-60px flex items-center justify-center">
                <img :src="item.imgUrl" alt="" />
              </div>
              <div class="text-center">{{ item.name }}</div>
            </div>
            <div class="flex-1 flex items-center ml-20px">
              {{ item.description }}
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>

    <!-- 编辑和删除和发布的提示弹窗 -->
    <el-dialog
      title="提示！"
      :visible.sync="visiable"
      class="small-dialog"
      v-dialogDrag
      :close-on-click-modal="false"
    >
      <div class="text-16px">{{ operateTitle }}</div>
      <div class="text-16px mt-10px">关联指标如下：</div>
      <div class="mt-10px overflow-auto">
        <div class="mt-5px text-color" v-for="(value, key, index) in errMsg" :key="index">
          <span>【{{ value.name }}】</span>
        </div>
      </div>
      <div slot="footer">
        <el-button v-if="showConfirmBtn" @click="confirmEdit" type="primary">{{
          confirmButtonText
        }}</el-button>
        <el-button @click="visiable = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MetricsManagementService from '@/services/MetricsManagementService'

export default {
  name: 'MetricsManagement',
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      treeData: [],
      defaultTreeProps: {
        children: 'child',
        label: 'name',
      },
      treeKeyword: '',
      treeLoading: false,
      treeDialogTitle: '',
      showTreeDialog: false,
      addTreeLoading: false,
      treeForm: {
        name: '',
        code: '',
        description: '',
        parentId: '', // 父级id，一级不用传
        idPath: '', // id路径，一级不用传
      },
      treeRules: {
        code: [
          { required: true, message: '指标域编码不能为空', trigger: 'blur' },
          {
            pattern: /^[a-z0-9]+$/, // 仅支持小写英文、数字
            message: '请输入符合规则的编码',
            trigger: 'blur',
          },
        ],
        name: [
          { required: true, message: '指标域名称不能为空', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9-\u4e00-\u9fa5]+$/, // 仅支持中英文、数字
            message: '请输入符合规则的名称',
            trigger: 'blur',
          },
        ],
      },
      tableLoading: '',
      search: {
        keyword: '',
        type: '',
        status: '',
        user: '',
      },
      typeList: [
        { label: '原子指标', value: '0' },
        { label: '派生指标', value: '1' },
        { label: '复合指标', value: '2' },
      ],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      showInventory: false,
      currentTreeNode: {},
      unitList: [],
      metricsTypes: [
        {
          name: '原子指标',
          description: '基于现有的数据模型生成原子指标',
          imgUrl: require('../../assets/images/atomic-indicators.png'),
          type: 0,
        },
        {
          name: '派生指标',
          description: '基于现有的指标+修饰词+时间周期，生成派生指标',
          imgUrl: require('../../assets/images/derived-metrics.png'),
          type: 1,
        },
        {
          name: '复合指标',
          description: '基于现有的指标，通过计算而成',
          imgUrl: require('../../assets/images/composite-metrics.png'),
          type: 2,
        },
      ],
      userList: [],
      currentMetricsDmainId: '', // 当前指标域id
      dataModelId: '', // 数据模型id
      currentMetricsId: '', // 当前指标id
      errMsg: {},
      visiable: false,
      operateTitle: '',
      showConfirmBtn: false,
      confirmButtonText: '',
      currentId: '',
      isExpandAll: false,
      showTree: true,
    }
  },
  methods: {
    // 懒加载子节点
    async loadTreeData(node, resolve) {
      this.isExpandAll = false
      if (node.level > 0) {
        const res = await MetricsManagementService.getMetricsDmain({
          ParentId: node.data.id,
          Sorting: '',
          SkipCount: 0,
          MaxResultCount: 999,
        })
        if (res && res.code === 0 && !_.isEmpty(res.data)) {
          const resData = _.map(res.data, (item) => {
            item.child = []
            return item
          })
          this.handleLazyLoad(node.data.id, this.treeData, resData)
          return resolve(resData)
        }
      }
      return resolve([])
    },
    // 处理懒加载数据
    handleLazyLoad(parentId, list, resData) {
      _.map(list, (item) => {
        if (item.id === parentId) {
          item.child = resData
        } else if (item.id !== parentId && item.child.length) {
          this.handleLazyLoad(parentId, item.child, resData)
        }
        return item
      })
    },
    // 根据子节点找父节点
    childFindParent(childId, data) {
      _.forEach(data, (item) => {
        if (item.id === childId) {
          this.currentTreeNode = item
        } else if (item.id !== childId && item.child) {
          this.showTree = false
          this.$nextTick(() => {
            this.isExpandAll = true
            this.showTree = true
          })
          this.childFindParent(childId, item.child)
        }
      })
    },
    // 根据父级id查询一级指标域
    async getMetricsDmain() {
      this.treeLoading = true
      const res = await MetricsManagementService.getMetricsDmain({
        ParentId: '00000000-0000-0000-0000-000000000000',
        Sorting: '',
        SkipCount: 0,
        MaxResultCount: 999,
      })
      this.treeLoading = false
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.treeData = _.map(res.data, (item) => {
          item.child = []
          return item
        })
        this.currentTreeNode = res.data[0]
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentTreeNode.id)
          this.findList()
        })
      }
    },
    // 根据关键字查询指标域
    async searchMetricsDmain() {
      this.treeLoading = true
      const res = await MetricsManagementService.searchMetricsDmain({
        nameOrCode: this.treeKeyword,
      })
      this.treeLoading = false
      if (res && res.code === 0 && res.data) {
        this.treeData = res.data
        if (this.currentMetricsDmainId) {
          await this.childFindParent(this.currentMetricsDmainId, this.treeData)
        } else {
          this.currentTreeNode = res.data[0]
        }
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentTreeNode.id)
          this.findList()
        })
      }
    },
    // 搜索指标域
    searchTreeData() {
      if (this.treeKeyword) {
        this.showTree = false
        this.$nextTick(() => {
          this.isExpandAll = true
          this.showTree = true
        })
        this.searchMetricsDmain()
      } else {
        this.showTree = false
        this.$nextTick(() => {
          this.isExpandAll = false
          this.showTree = true
        })
        this.getMetricsDmain()
      }
    },
    // 点击指标域域节点
    handleDocNodeClick(data) {
      this.currentTreeNode = data
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.currentTreeNode.id)
        this.findList()
      })
    },
    // 查找父级id
    findParentId(id) {
      const idPath = []
      _.forEach(this.treeData, (item) => {
        if (item.id === id) {
          idPath.push(item.id)
        } else if (item.id !== id && item.child.length) {
          _.forEach(item.child, (cItem) => {
            if (cItem.id === id) {
              idPath.push(cItem.parentId)
              idPath.push(cItem.id)
            }
          })
        }
      })
      return idPath
    },
    // 处理树节点
    handleTreeData(e, type, data) {
      if (e && e.stopPropagation) {
        e.stopPropagation()
      } else {
        e.cancelBubble = true
      }
      if (type === 'createParentId') {
        // 新增父节点
        this.treeDialogTitle = '新增指标域'
        this.showTreeDialog = true
      } else if (type === 'create') {
        // 新增子节点
        this.treeDialogTitle = '新增指标域'
        this.showTreeDialog = true
        this.treeForm.parentId = data.id
        this.treeForm.idPath = this.findParentId(data.id).join(',')
      } else if (type === 'update') {
        this.treeDialogTitle = '编辑指标域'
        this.treeForm = _.cloneDeep(data)
        this.showTreeDialog = true
      }
    },
    // 新增和编辑指标域
    saveTreeData() {
      this.$refs.treeForm.validate(async (valid) => {
        if (valid) {
          this.addTreeLoading = true
          if (this.treeDialogTitle === '新增指标域') {
            const res = await MetricsManagementService.createMetricsDmain(this.treeForm)
            if (res && res.code === 0) {
              this.$message.success('新增成功')
            }
          } else {
            const res = await MetricsManagementService.updateMetricsDmain(
              this.treeForm.id,
              this.treeForm
            )
            if (res && res.code === 0) {
              this.$message.success('修改成功')
            }
          }
          this.addTreeLoading = false
          this.closeTreeDialog()
          this.searchTreeData()
        }
      })
    },
    // 关闭指标域弹窗
    closeTreeDialog() {
      this.$refs.treeForm.resetFields()
      this.treeForm = this.$options.data().treeForm
      this.showTreeDialog = false
    },
    // 搜索指标列表
    async findList() {
      this.tableLoading = true
      const res = await MetricsManagementService.getMetricsList({
        NameOrCode: this.search.keyword,
        Type: this.search.type,
        IsPublish: this.search.status,
        CreatedUserName: this.search.user,
        Sorting: 'created_time desc',
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
        MetricsDmainId: this.currentTreeNode.id, // 指标域id
        DataModelId: this.dataModelId,
      })
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = _.map(res.data, (item) => {
          if (item.type === 0) {
            item.typeName = '原子指标'
          } else if (item.type === 1) {
            item.typeName = '派生指标'
          } else if (item.type === 2) {
            item.typeName = '复合指标'
          }
          return item
        })
        this.page.total = res.totalCount
        if (this.currentMetricsId) {
          const currentRow = _.find(this.tableData, ['id', this.currentMetricsId])
          if (currentRow) {
            this.$nextTick(() => {
              this.$refs.table.setCurrentRow(currentRow)
            })
          }
        }
      }
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.findList()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.findList()
    },
    // 删除指标域
    removeTreeData(id) {
      this.$confirm('是否确定要删除该指标域', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await MetricsManagementService.deleteMetricsDmain(id)
        if (res && res.code === 0) {
          this.$message.success('指标域删除成功')
          this.searchTreeData()
        }
      })
    },
    // 重置
    reset() {
      this.search = this.$options.data().search
      this.dataModelId = ''
      this.findList()
    },
    async toDetail(type, operate, id, isPublish) {
      this.currentId = id
      this.showInventory = false
      let path = ''
      if (type === 0) {
        // 原子指标
        path = './atomic-indicators'
      } else if (type === 1) {
        // 派生指标
        path = './derived-metrics'
      } else if (type === 2) {
        // 复合指标
        path = './composite-metrics'
      }
      if (operate === 'add') {
        this.$router.push(
          `${path}?metricsDmainId=${this.currentTreeNode.id}&metricsDmainName=${this.currentTreeNode.name}&type=${operate}`
        )
      } else if (operate === 'update') {
        // 校验是否关联指标
        // 当指标关闭时，需要校验是否存在已发布的依赖指标
        this.errMsg = {}
        if (!isPublish) {
          this.errMsg = await this.isExistDepend(id, !isPublish)
        }
        if (!_.isEmpty(this.errMsg)) {
          this.showDialog('update')
        } else {
          this.$router.push(`${path}?id=${id}&type=${operate}`)
        }
      } else if (operate === 'copy') {
        this.$router.push(`${path}?id=${id}&type=${operate}`)
      }
    },
    // 获取指标创建人
    async getMetricsUser() {
      const res = await MetricsManagementService.getMetricsUser({
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        name: '',
      })
      if (res && res.code === 0 && res.data) {
        this.userList = res.data
      }
    },
    // 删除指标
    async deleteMetrics(row) {
      // 校验是否关联指标
      this.errMsg = {}
      this.errMsg = await this.isExistDepend(row.id)
      if (!_.isEmpty(this.errMsg)) {
        this.showDialog('delete')
      } else {
        this.$confirm('是否确定要删除该指标', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await MetricsManagementService.deleteMetrics(row.id)
          if (res && res.code === 0) {
            this.$message.success('指标删除成功')
            this.findList()
          }
        })
      }
    },
    // 修改发布状态
    async updatePublish(row) {
      // 校验是否关联指标
      const isPublish = row.isPublish
      // 当指标关闭时，需要校验是否存在已发布的依赖指标
      this.errMsg = {}
      if (!isPublish) {
        this.errMsg = await this.isExistDepend(row.id, !row.isPublish)
      }
      if (!_.isEmpty(this.errMsg)) {
        this.showDialog('publish')
        const index = _.findIndex(this.tableData, ['id', row.id])
        this.tableData[index].isPublish = !this.tableData[index].isPublish
      } else {
        const res = await MetricsManagementService.updatePublish({
          metricsId: row.id,
          isPublish: row.isPublish,
        })
        if (res && res.code === 0) {
          this.$message.success('修改发布状态成功')
          this.findList()
        } else {
          const index = _.findIndex(this.tableData, ['id', row.id])
          this.tableData[index].isPublish = !this.tableData[index].isPublish
        }
      }
    },
    // 指标数据
    toMetricsData(row) {
      this.$router.push(
        `./metrics-data?type=${row.type}&id=${row.id}&metricsDmainName=${row.metricsDmainName}`
      )
    },
    // 是否存在依赖,并且是已发布状态
    async isExistDepend(id, isPublish) {
      const res = await MetricsManagementService.isExistDepend({
        id,
        isPublish,
      })
      if (res && res.code === 0 && res.details) {
        return res.details
      }
      return {}
    },
    showDialog(type) {
      this.visiable = true
      if (type === 'update') {
        this.operateTitle = '编辑后会导致已发布的指标数据无法展示及关联指标无法引用！'
        this.showConfirmBtn = true
        this.confirmButtonText = '继续编辑'
      } else if (type === 'delete') {
        this.operateTitle = '数据模型已关联指标，请先删除关联指标，再删除数据模型！'
        this.showConfirmBtn = false
      } else if (type === 'publish') {
        this.operateTitle = '请先关闭关联指标！'
        this.showConfirmBtn = false
      }
    },
    // 继续编辑
    confirmEdit() {
      let path = ''
      if (type === 0) {
        // 原子指标
        path = './atomic-indicators'
      } else if (type === 1) {
        // 派生指标
        path = './derived-metrics'
      } else if (type === 2) {
        // 复合指标
        path = './composite-metrics'
      }
      this.$router.push(`${path}?id=${currentId}&type=update`)
    },
  },
  created() {
    this.currentMetricsDmainId = this.$route.query.metricsDmainId || ''
    this.dataModelId = this.$route.query.dataModelId || ''
    this.currentMetricsId = this.$route.query.metricsId || ''
    this.getMetricsUser()
    if (this.currentMetricsDmainId) {
      this.searchMetricsDmain()
    } else {
      this.searchTreeData()
    }
  },
}
</script>

<style lang="scss" scoped>

.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
li {
  border: 2px solid transparent;
}
li:hover {
  border: 2px solid #0082f7;
}
.text-color {
  color: var(--systemMainColor);
}

</style>
